import dayjs from 'dayjs';
import { useState } from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import moment from 'moment';

export default function TimePickerComponent({ sendTimeFromChild, timeInput, name }) {
	const [value, setValue] = useState(null);

	const handleTime = (newValue) => {
		setValue(newValue);
		sendTimeFromChild({ "name": name, "time": moment(newValue.$d).format() });
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['TimePicker']}>
                <TimePicker
                name={name}
                value={value || dayjs(timeInput, 'hh:mm A')}
                onChange={(newValue) => handleTime(newValue)}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "&:hover > fieldset": { 
                            border: '2px solid #E6E6E6', // Green border on hover
                        },
                        "& fieldset": {
                            borderColor: "#E6E6E6", // Default border color
                            border: '2px solid #E6E6E6',
                            borderRadius: '8px',
                        },
                        "& .MuiInputBase-input": {
                            fontSize: '1rem', // Font size for the input text
                            color: '#000', // Text color
                            padding: '14px 13px 14px 13px', // Input padding
                            background: "#FFF",
                        },
                    },
                    "& .MuiPickersClock-circle": {
                        backgroundColor: '#e0f7fa', // Custom background for clock circle
                    }
                }}
                />
            </DemoContainer>
        </LocalizationProvider>
	);
}
